/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { BodyText, Icon, IconSet, Tooltip } from '@postscript/components';

import { useAIPlanBillingStatus } from 'components/billing/modules/plans/hooks/useAIPlanBillingStatus';
import { Flex, Stack } from 'components/layout';
import { TooltipPortal } from 'components/shopper/components/shared/TooltipPortal';

import { formatCentsToDollars } from 'components/billing/common/utils';

export const PRICING_TOOLTIP_ID = 'tooltip-ai-pricing';

export const PricingTooltipPortal = () => {
  const { currentPlan, defaultAIPlan } = useAIPlanBillingStatus();

  const aiPlan = currentPlan || defaultAIPlan;

  if (!aiPlan) {
    return null;
  }

  return (
    <TooltipPortal>
      <Tooltip id={PRICING_TOOLTIP_ID} size="small">
        <div style={{ minWidth: '250px' }}>
          <Stack gap="var(--spacing-3)">
            {aiPlan.platformFee > 0 && (
              <Flex justifyContent="space-between">
                <BodyText size="small" bold color="white">
                  Platform Fee
                </BodyText>
                <BodyText size="small" bold color="white">
                  {formatCentsToDollars(aiPlan.platformFee)}
                </BodyText>
              </Flex>
            )}

            <Stack>
              <BodyText size="small" bold color="white">
                Infinity Testing
              </BodyText>
              <Flex justifyContent="space-between">
                <BodyText size="small" color="var(--gray-3)">
                  Automation
                </BodyText>
                <BodyText size="small" bold color="white">
                  {formatCentsToDollars(aiPlan.itAutomationFee)}/msg
                </BodyText>
              </Flex>
              <Flex justifyContent="space-between">
                <BodyText size="small" color="var(--gray-3)">
                  Campaign
                </BodyText>
                <BodyText size="small" bold color="white">
                  {formatCentsToDollars(aiPlan.itCampaignFee)}/msg
                </BodyText>
              </Flex>
            </Stack>

            <Flex justifyContent="space-between">
              <BodyText size="small" bold color="white">
                Shopper
              </BodyText>
              <BodyText size="small" bold color="white">
                {formatCentsToDollars(aiPlan.shopperResponseFee)}/msg
              </BodyText>
            </Flex>

            <Flex justifyContent="space-between">
              <BodyText size="small" bold color="white">
                Shopper Automations
              </BodyText>
              <BodyText size="small" bold color="white">
                {formatCentsToDollars(aiPlan.shopperAutomationFee)}/msg
              </BodyText>
            </Flex>
          </Stack>
        </div>
      </Tooltip>
    </TooltipPortal>
  );
};

export const PricingTooltip = () => {
  return (
    <>
      <div
        aria-describedby={PRICING_TOOLTIP_ID}
        data-for={PRICING_TOOLTIP_ID}
        data-tip
        tabIndex={0}
        style={{
          color: 'black',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '3px',
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
      >
        <Icon component={IconSet.Information} size="small" />
        View Pricing Details
      </div>
      <PricingTooltipPortal />
    </>
  );
};
